import { render, staticRenderFns } from "./CollectionProductsComplementary.vue?vue&type=template&id=465ed9a0&name=collection-products-complementary&"
import script from "./CollectionProductsComplementary.vue?vue&type=script&lang=js&"
export * from "./CollectionProductsComplementary.vue?vue&type=script&lang=js&"
import style0 from "./CollectionProductsComplementary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports